import React, { FC } from "react";
import { Box, Stack, Typography } from "@mui/material";

interface Props {
  url: string;
  width?: string;
  height?: string;
  center?: boolean;
  caption?: string;
}

const Image: FC<Props> = ({ url, width, height, caption, center = false }) => {
  return (
    <Stack
      sx={{
        marginBottom: "24px",
        maxWidth: width || "100%",
        maxHeight: height || "unset",
        marginX: center ? "auto" : "0px",
      }}
    >
      <Box component="img" src={url} width="100%" />
      {caption && (
        <Typography
          variant="caption"
          sx={{
            marginTop: "12px",
            marginBottom: "8px",
            fontSize: "14px",
            lineHeight: "20px",
            fontWeight: "400",
            color: "#000",
          }}
        >
          {caption}
        </Typography>
      )}
    </Stack>
  );
};

export default Image;
